import { prepHandleEvent } from "./prepHandleEvent";

export function handleCut(canvas) {
  return function (event) {
    if (document.activeElement === canvas) {
      event.stopPropagation();
      event.preventDefault();
    }
    var myApp = prepHandleEvent(this, false, null, null);
    if (myApp == null) return;

    myApp.HandleCut(event);
  };
}
